import { render, staticRenderFns } from "./omMaintenanceRequest.vue?vue&type=template&id=10bb3cde"
import script from "./omMaintenanceRequest.ts?vue&type=script&lang=js&external"
export * from "./omMaintenanceRequest.ts?vue&type=script&lang=js&external"
import style0 from "./omMaintenanceRequest.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports